export default "__VITE_ASSET__70d67cdc__"